const screeningPolicyEndpoints = {
  policy: () => "/screening/policy",
  history: () => "/screening/policy/history",
};

export default screeningPolicyEndpoints;
